import { GlButton, GlForm, GlFormFields, GlLink, GlSprintf } from '@gitlab/ui';
import { formValidators } from '@gitlab/ui/src/utils';
import illustration from '@gitlab/svgs/dist/illustrations/empty-state/empty-secrets-md.svg?url';
import csrf from '~/lib/utils/csrf';
import { s__ } from '~/locale';
import { helpPagePath } from '~/helpers/help_page_helper';
import { PASSWORD_MANAGER_IGNORE_ATTRS } from '~/lib/utils/forms';
import { newAdminSessionPath } from '~/lib/utils/path_helpers/instance_admin';
import { newUserSessionPath } from '~/lib/utils/path_helpers/routes';
import VerificationLayout from './verification_layout.vue';
export default {
    name: 'RecoveryCode',
    components: {
        GlButton,
        GlForm,
        GlFormFields,
        GlLink,
        GlSprintf,
        VerificationLayout
    },
    props: {
        path: {
            type: String,
            required: true
        },
        adminMode: {
            type: Boolean,
            required: false,
            default: false
        },
        rememberMe: {
            type: String,
            required: true
        },
        rememberMeEnabled: {
            type: Boolean,
            required: true
        }
    },
    data () {
        return {
            values: {
                otpAttempt: ''
            }
        };
    },
    methods: {
        newUserSessionPath,
        newAdminSessionPath
    },
    csrf,
    illustration,
    recoveryCodesHelpPath: helpPagePath('user/profile/account/two_factor_authentication', {
        anchor: 'recovery-codes'
    }),
    sshHelpPath: helpPagePath('user/profile/account/two_factor_authentication_troubleshooting', {
        anchor: 'regenerate-recovery-codes-with-ssh'
    }),
    fields: {
        otpAttempt: {
            // Intentionally no otp-named id here: an otp-flavored id prompts password managers to
            // autofill OTP codes into the recovery field. The name stays user[otp_attempt] (the
            // backend param) until it is renamed in
            // https://gitlab.com/gitlab-org/gitlab/-/work_items/579319
            label: s__('TwoFactorAuth|Recovery code'),
            validators: [
                formValidators.required(s__('TwoFactorAuth|Recovery code is required.'))
            ],
            inputAttrs: {
                ...PASSWORD_MANAGER_IGNORE_ATTRS,
                autocomplete: 'off',
                autofocus: true,
                'data-testid': 'recovery-code-field',
                name: 'user[otp_attempt]'
            }
        }
    }
};
